import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { IAutoCompleteData } from '../../interfaces/i-auto-complete-data';

@Component({
  selector: 'app-auto-complete-with-add',
  templateUrl: './auto-complete-with-add.component.html',
  styleUrls: ['./auto-complete-with-add.component.scss'],
})
export class AutoCompleteWithAddComponent {
  @Input() searchList: IAutoCompleteData[];
  @Input() exactMatch: IAutoCompleteData;
  @Input() isSearching: boolean;
  @Input() control: FormControl;
  @Input() placeholder: string = 'Search';
  @Input() addNewText: string;

  @Output() handleAddNew: EventEmitter<string> = new EventEmitter();

  public ADD_NEW_OPTION = 'ADD_NEW_OPTION';

  constructor(private dialogService: DialogService) {}

  displayWith(obj?: any): string | undefined {
    return obj?.displayName ? obj.displayName : undefined;
  }

  onOptionSelected($event) {
    if ($event.option.id === this.ADD_NEW_OPTION) {
      this.dialogService
        .openConfirmationDialog({
          title: `Add new ${this.addNewText}`,
          message: `Are you sure you want to add the new ${this.addNewText} "${$event.option.value}"?`,
          confirmLabel: 'Yes',
          cancelLabel: 'No',
        })
        .afterClosed()
        .subscribe((dialogResponse) => {
          if (dialogResponse) {
            this.handleAddNew.emit($event.option.value);
          } else {
            this.clearSelection();
          }
        });
    }
  }

  clearSelection() {
    this.control.setValue('');
    this.searchList = null;
  }
}
